// Components
import { LegalPageContent } from '../../components/LegalPageContent/LegalPageContent';

export const SecurityAddendumPage = () => {
  return <LegalPageContent slug="security-addendum" fallbackTitle="Security Addendum" />;
};
